import React from 'react'
import { Cylinder } from '../geometries/Cylinder'
import { Pot } from './Pot'

export const Tree = ({ position, scale = 1 }) => {
	return (
		<group castShadow position={position} scale={scale}>
			<Pot scale={13} />
			<Cylinder size={[3, 4, 100, 50]} position={[0, 60, 0]} color='peru' />
			<mesh position={[0, 100, 0]} rotation={[Math.PI / 2, 0, 0]} castShadow>
				<torusKnotGeometry args={[10, 10, 60, 50, 19, 10]} />
				<meshStandardMaterial color={'green'} />
			</mesh>
		</group>
	)
}
